import { render, staticRenderFns } from "./wikiarticledetail.vue?vue&type=template&id=47bc1a51&scoped=true"
import script from "./wikiarticledetail.vue?vue&type=script&lang=js"
export * from "./wikiarticledetail.vue?vue&type=script&lang=js"
import style0 from "./wikiarticledetail.vue?vue&type=style&index=0&id=47bc1a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc1a51",
  null
  
)

export default component.exports